/* eslint-disable no-unused-vars */
/* eslint-disable no-sequences */
import moment from 'moment';
import Components from "mpm-components";
import Utilities from "mpm-config/Utilities";
import MPMContext from "mpm-config/context/MPMContext";
import mpmServices from "mpm-services";
import React from "react";
import { Divider, Form, Grid, GridColumn, Menu } from "semantic-ui-react";
const options = [
    { key: 'm', text: 'MAROC', value: 'morocco' },
  ]
const ProfileComponent = (props) => {
    const context = React.useContext(MPMContext);
    const [loading, setLoading] = React.useState(true);
    const [formData, setFormData] = React.useState(context.connectedUser);

    return <>
<Components.Regions.RegionWithHeader 
                title="label.profile"
                headerColor="blue"
                headerSize="small">
        <Form>
        <Form.Group widths='equal'>
          <Form.Input fluid label='Nom' disabled value={formData.prenom} placeholder='Nom' />
          <Form.Input fluid label='Prénom' disabled value={formData.nom} placeholder='Prénom' />
        </Form.Group>
        <Divider />
        <Form.TextArea label='Adresse' placeholder='Adresse' disabled/>
        <Form.Group widths="equal">
        <Form.Input disabled fluid label='Code Postale' placeholder='Code Postale' />
        <Form.Input disabled fluid label='Province' placeholder='Province' />
        <Form.Select disabled
            fluid
            label='Pays'
            value="morocco"
            options={options}
            placeholder='Pays'
          />
        </Form.Group>
      </Form>
    </Components.Regions.RegionWithHeader>

    <Components.Regions.RegionWithHeader 
                title="label.lastconnexion"
                headerColor="blue"
                headerSize="small">
        <Form>
        <Form.Input fluid label='' disabled value={moment(formData.lastConnexion).format("DD/MM/YYYY HH:mm:ss")} placeholder='First name' />
      </Form>
    </Components.Regions.RegionWithHeader>


    </>
}

export const MotDePasseComponent = (props) => {
    const context = React.useContext(MPMContext);
    const [loading, setLoading] = React.useState(false)
    const [formData, setFormData] = React.useState({
        actual : "",
        password : "",
        confirmation : ""
    });
    const [message, setMessage] = React.useState(null);

    const submitForm = () => {
        const {actual, password, confirmation} = formData; 
        if(!actual || actual.length === 0){
            setMessage({
                warning: true,
                header: "Validation",
                content: `Ancien Mot de passe est obligatoire`,
              });
              return;
        }
        if(!password ||password.length === 0){
            setMessage({
                warning: true,
                header: "Validation",
                content: `Nouveau Mot de passe est obligatoire`,
              });
              return;
        }
        
        if(!confirmation || confirmation.length === 0){
            setMessage({
                warning: true,
                header: "Validation",
                content: `Confirmation du Nouveau Mot de passe est obligatoire`,
              });
              return;
        }
        if(confirmation && confirmation !== password){
            setMessage({
                warning: true,
                header: "Validation",
                content: `Nouveau mot de passe et la confirmation ne sont pas identique`,
              });
              return;
        }
        setLoading(true);

        mpmServices.UserDataService.changePassword({
            login: context.connectedUser.login,
            newPassword : formData.password,
            oldPassword : formData.actual
        }).then(result => {
            setLoading(false);
            if(result.success){
                setMessage({
                    success: true,
                    header: "Changement de mot de passe",
                    content: "Votre mot de passe a été changé avec succée. veuillez vous reconnecté",
                  });
                  setTimeout(() => {
                      context.setUserData({...context.connectedUser, firstConnexion : false})
                  }, 1000);
            }else{
                setMessage({
                    error: true,
                    header: "Changement de mot de passe",
                    content: result.message,
                  });
            }
        }).catch(error => {
            setLoading(false);
            setMessage({
                error: true,
                header: "Changement de mot de passe",
                content: "Une Erreur est survenue lors de changement du mot de passe. veuillez réssayer ou contactez votre administrateur",
              });
        }) 


        
    }
    const onChangeData = (name, value) => {
        setFormData({
            ...formData, [name] : value
        })
    }
    return  <Components.Regions.RegionWithHeader 
    title="label.change.password"
    headerColor="blue"
    headerSize="small" >
        {message && (
                <Components.Message {...message} onClose={() => setMessage(null)} />
            )}
    <Form>
        <Form.Input   type='password' fluid label='Ancien Mot de passe' disabled={loading} value={formData.actual} onChange={(e) => onChangeData("actual", e.target.value)} placeholder='' />
        <Form.Input   type='password'  fluid label='Nouveau Mot de passe'  disabled={loading} value={formData.password} onChange={(e) => onChangeData("password", e.target.value)} placeholder='' />
        <Form.Input   type='password'  fluid label='Confirmation Mot de passe' disabled={loading}  value={formData.confirmation} onChange={(e) => onChangeData("confirmation", e.target.value)} placeholder='' />
        <Divider />
        
        <Form.Button primary onClick={() => submitForm()} loading={loading}>Changer le mot de passe</Form.Button>
    </Form>
</Components.Regions.RegionWithHeader>
   
}
export default (props) => {
    
    const [activeMenu, setActiveMenu] = React.useState('Profil')
    React.useEffect(() => {

    }, [])

    const handleItemClick = (e, { name }) => setActiveMenu(name)
    return (
        
        <>
        <Components.Regions.BreadCrumb data={Utilities.getBreadCrumbData(["Profil", "Paramètres"])} size="tiny" />
        <Grid stretched verticalAlign="top">
            <GridColumn width="5"> 
                 <Menu fluid pointing secondary vertical>
                    <Menu.Item
                    name='Profil'
                    active={activeMenu === 'Profil'}
                    onClick={handleItemClick}
                    />
                    <Menu.Item
                    name='Mot de passe'
                    active={activeMenu === 'Mot de passe'}
                    onClick={handleItemClick}
                    />
            
                </Menu>
            </GridColumn>

            <GridColumn width="11">
                {
                    activeMenu === 'Profil' && <ProfileComponent />
                }
                {
                    activeMenu === 'Mot de passe' && <MotDePasseComponent />
                }
            </GridColumn>
        </Grid>
        </>
        )
}